export default "__VITE_ASSET__kJbnwu0P__"